export const ProfileImage = () => {
  return (
    <div className="flex justify-start items-center w-full my-0 mx-auto">
      <img
        className="rounded-[50%] max-h-[150px]"
        alt="profile"
        src="/images/profile-picture.jpg"
      />
    </div>
  );
};
